const {
        BURYATIA,
        CHECHNYA,
        CHUVA,
        CRIMEA,
        HMAO,
        KARELIA,
        KRASNODAR,
        KURGAN,
        KURSK,
        MARIEL,
        ORENB,
        ORLOV,
        PRIMOR,
        PSCOV,
        SAAS,
        SAHALIN,
        SVERD,
        TATAR,
        VOLGOGRAD,
        YANAO,
        LEN,
        TAMBOV,
        KAMCHATKA,
        CHUKOTKA,
        TULA
      } = require('./region')

const APP_NAME = {
  default:     'ТКО',
  [BURYATIA]:  'ТКО Республика Бурятия',
  [CHECHNYA]:  'ТКО Чеченская Республика',
  [CHUVA]:     'ТКО Чувашская Республика',
  [CRIMEA]:    'ТКО Республика Крым',
  [HMAO]:      'ТКО ХМАО',
  [KARELIA]:   'ТКО Республика Карелия',
  [KRASNODAR]: 'ТКО Краснодарский край',
  [KURGAN]:    'ТКО Курганская область',
  [KURSK]:     'ТКО Курская область',
  [MARIEL]:    'ТКО Республика Марий Эл',
  [ORENB]:     'ТКО Оренбургская область',
  [ORLOV]:     'ТКО Орловская область',
  [PRIMOR]:    'ТКО Приморский край',
  [PSCOV]:     'ТКО Псковская область',
  [SAAS]:      'Муниципальная автоматизированная система обращения с отходами',
  [SAHALIN]:   'ТКО Сахалинская область',
  [SVERD]:     'ТКО Свердловская область',
  [TATAR]:     'ТКО Республика Татарстан',
  [VOLGOGRAD]: 'ТКО Волгоградская область',
  [YANAO]:     'ТКО Ямало-Ненецкий автономный округ',
  [LEN]:       'ТКО Ленинградская область',
  [TAMBOV]:    'ТКО Тамбовская область',
  [TULA]:      'ТКО Тульская область',
  [CHUKOTKA]:  'ТКО Чукотский автономный округ',
  [KAMCHATKA]: 'ТКО Камчатский край'
}

module.exports.APP_NAME = APP_NAME
